export default "__VITE_ASSET__CXEMFo$D__"